import { useEffect, useState } from "react";
import { getDatasetFieldOptions } from "../lib/serverComm";
import { DatasetName } from "@/common/constants";
import { FilterName } from "@/common/filters";

export interface FieldOption {
  label: string;
  value: string;
}

export const useFieldOptions = (
  datasetName: DatasetName,
  filterDefinitionName: FilterName,
) => {
  const [options, setOptions] = useState<FieldOption[]>([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    const fetchOptions = async () => {
      if (!datasetName || !filterDefinitionName) {
        setOptions([]);
        return;
      }

      try {
        setLoading(true);
        setError(null);
        const response = await getDatasetFieldOptions(
          datasetName,
          filterDefinitionName,
        );
        if (!Array.isArray(response)) {
          throw new Error("Invalid response format");
        }
        if (response.length > 0 && typeof response[0] !== "object") {
          setOptions(
            response.map((value) => ({
              label: String(value),
              value: String(value),
            })),
          );
          return;
        }
        setOptions(response);
      } catch (err) {
        console.error("Error fetching field options:", err);
        setError("Failed to load options");
        setOptions([]);
      } finally {
        setLoading(false);
      }
    };

    fetchOptions();
  }, [datasetName, filterDefinitionName]);

  return { options, loading, error };
};
